import { HttpRequest } from '../../components/HttpRequest';

export const ordersApi = {
  /**
   * Fetch customer orders with pagination and status filtering
   * API: GET /api/v1/ecommerce/getzedecommercecustomerorder
   */
  async getCustomerOrders(customerId, page = 1, limit = 10, orderStatus = '') {
    try {
      const url = `/api/v1/ecommerce/getzedecommercecustomerorder?customerId=${customerId}&page=${page}&limit=${limit}&orderStatus=${orderStatus}`;
      const response = await HttpRequest({
        method: 'GET',
        url: url
      });

      if (response?.status === 200 || response?.status === 201) {
        // Sort orders by orderNumber in descending order
        const ascOrders = response?.response?.data?.sort((a, b) => parseInt(b.orderNumber) - parseInt(a.orderNumber));
        return {
          success: true,
          data: ascOrders,
          total: response?.response?.count,
          status: response?.status
        };
      }

      return {
        success: false,
        data: [],
        total: 0,
        message: 'Failed to fetch orders',
        status: response?.status
      };
    } catch (error) {
      console.error('Error fetching customer orders:', error);
      return {
        success: false,
        data: [],
        total: 0,
        error: error.message || 'Failed to fetch orders',
        status: 500
      };
    }
  },

  /**
   * Fetch order details by order ID
   */
  async getOrderById(orderId) {
    try {
      const response = await HttpRequest({
        method: 'GET',
        url: `/api/v1/ecommerce/getzedecommercecustomerorder/${orderId}`
      });

      if (response?.status === 200 || response?.status === 201) {
        return {
          success: true,
          data: response?.response?.data,
          status: response?.status
        };
      }

      return {
        success: false,
        data: null,
        message: 'Failed to fetch order details',
        status: response?.status
      };
    } catch (error) {
      console.error('Error fetching order details:', error);
      return {
        success: false,
        data: null,
        error: error.message || 'Failed to fetch order details',
        status: 500
      };
    }
  },

  /**
   * Legacy API client method - kept for compatibility
   */
  async create(orderData) {
    try {
      const response = await HttpRequest({
        method: 'POST',
        url: '/api/orders',
        body: orderData
      });
      return {
        data: response?.response?.data,
        status: response?.status,
        message: 'Order created successfully'
      };
    } catch (error) {
      return {
        error: error.message || 'Failed to create order',
        status: error?.status || 500
      };
    }
  },

  /**
   * Legacy API client method - kept for compatibility
   */
  async getById(orderId) {
    try {
      const response = await HttpRequest({
        method: 'GET',
        url: `/api/orders/${orderId}`
      });
      return {
        data: response?.response?.data,
        status: response?.status
      };
    } catch (error) {
      return {
        error: error.message || 'Failed to fetch order',
        status: error?.status || 500
      };
    }
  },

  /**
   * Legacy API client method - kept for compatibility
   */
  async updateOrderStatus(orderId, status) {
    try {
      const response = await HttpRequest({
        method: 'PATCH',
        url: `/api/orders/${orderId}/status`,
        body: { status }
      });
      return {
        data: response?.response?.data,
        status: response?.status,
        message: 'Order status updated successfully'
      };
    } catch (error) {
      return {
        error: error.message || 'Failed to update order status',
        status: error?.status || 500
      };
    }
  },

  /**
   * Legacy API client method - kept for compatibility
   */
  async cancelOrder(orderId) {
    try {
      const response = await HttpRequest({
        method: 'POST',
        url: `/api/orders/${orderId}/cancel`
      });
      return {
        status: response?.status,
        message: 'Order cancelled successfully'
      };
    } catch (error) {
      return {
        error: error.message || 'Failed to cancel order',
        status: error?.status || 500
      };
    }
  }
};